module.exports = __webpack_public_path__ + "static/media/UTKM.ebe2f032.png";